// Fixes crash in pdfjs-dist/build/pdf.mjs for older browsers
export function addPromiseWithResolversPolyfill() {
  if (typeof Promise.withResolvers === 'undefined') {
    console.log(`adding Promise.withResolvers polyfill`);
    Promise.withResolvers = <T>(): {
      promise: Promise<T>;
      resolve: (value: T | PromiseLike<T>) => void;
      // biome-ignore lint/suspicious/noExplicitAny: any is needed for the reject function
      reject: (reason?: any) => void;
    } => {
      let resolve: (value: T | PromiseLike<T>) => void;
      let reject: (reason?: unknown) => void;

      const promise = new Promise<T>((res, rej) => {
        resolve = res;
        reject = rej;
      });

      // @ts-expect-error - code copied from https://github.com/storybookjs/vite-plugin-storybook-nextjs/blob/b70fa8cbe905240c247a5d84a6baf7b546f18753/src/polyfills/promise-with-resolvers.ts
      return { promise, resolve, reject };
    };
  }
}
